import { action, makeObservable, observable, reaction } from 'mobx';
import { UiStore } from './ui';
import { appConfig } from '../settings';
import { IFilterParams, IOrdersListItem } from '../interfaces';
import { getOrdersList } from '../middleware';
import { apiParamsCleaner } from '../instruments';

export class OrdersStore {
    private constructor() {
        makeObservable(this);
        reaction(
            () => this.forcedUpdateTime,
            () => {
                const UiStoreInstance = UiStore.getInstance();
                const params = UiStoreInstance.params;
                const cleanParams = apiParamsCleaner(params, this.filterParams);
                getOrdersList(cleanParams).then();
            },
            {
                delay: appConfig.APIDelay,
            },
        );
    }

    private static instance: OrdersStore;
    public static getInstance(): OrdersStore {
        if (!OrdersStore.instance) {
            OrdersStore.instance = new OrdersStore();
        }
        return OrdersStore.instance;
    }

    @observable list: IOrdersListItem[] = [];
    @action setList(list: IOrdersListItem[]): void {
        this.list = list;
    }

    @action cleanStore(): void {
        this.list = [];
    }

    @observable forcedUpdateTime = 0;
    @action setForcedUpdateTime(): void {
        this.forcedUpdateTime = Date.now();
    }

    @observable filterParams: IFilterParams = {
        pageNumber: true,
        pageSize: true,
        search: true,
        companyId: true,
    };
}
